<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="apprentice-simple-card">
                    <ckeditor
                        id="slide-text-input"
                        v-model="editorValue"
                        ref="editorInstance"
                        :editor="editor"
                        :config="editorConfig"
                        @click="changeEditorBackground"
                        @ready="onEditorReady">
                    </ckeditor>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';
import Vue from 'vue';

export default {
    name: 'design-2021-presentation-edit-text-type-component',
    props: {
        slideIn: Object,
    },
    data() {
        return {
            editor: ApprenticeEditor,
            editorInstance: null,
            editorConfig: {
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'imageInsert',
                        'mediaEmbed',
                        'insertTable',
                        '|',
                        'fontColor',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'highlight',
                        'specialCharacters',
                        '|',
                        'horizontalLine',
                    ],
                },
                language: this.$authUser.locale,
                image: {
                    toolbar: [
                        'imageTextAlternative',
                        '|',
                        'imageStyle:alignLeft',
                        'imageStyle:alignRight',
                        'imageStyle:alignCenter',
                        'imageStyle:alignBlockLeft',
                        'imageStyle:alignBlockRight',
                        'imageStyle:inline',
                        '|',
                        'linkImage',
                    ],
                },
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
        };
    },
    computed: {
        editorValue: {
            //necessary because of all the weird stuff with the background color.
            get() {
                return this.slideIn.value !== null ? this.slideIn.value : '';
            },
            set(newValue) {
                this.$emit('update-slide-value', newValue);
            },
        },
    },
    methods: {
        onEditorReady(editor) {
            this.editorInstance = editor;
            this.applyBackgroundColor(this.slideIn.color || '#ffffff');

            // Attach focus and blur event listeners
            const editableElement = this.editorInstance.ui.view.editable.element;
            // Use MutationObserver to monitor changes after blur
            this.observer = new MutationObserver(() => {
                this.changeEditorBackground();
            });

            this.observer.observe(editableElement, { attributes: true, childList: true, subtree: true });
        },

        changeEditorBackground() {
            // When the background color changes dynamically, apply it to the editable area
            if (this.editorInstance) {
                const color = this.slideIn.color || '#ffffff';
                this.applyBackgroundColor(color);
            }
        },

        applyBackgroundColor(color) {
            // Apply background color to the correct editable element
            if (this.editorInstance) {
                Vue.nextTick(() => {
                    const editableElement = this.editorInstance.ui.view.editable.element;
                    if (editableElement) {
                        editableElement.style.backgroundColor = color;
                    }

                    this.editorInstance.model.change((writer) => {
                        const root = this.editorInstance.model.document.getRoot();
                        writer.setAttribute('backgroundColor', color, root);
                    });
                });
            }
        },
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
};
</script>

<style scoped lang="scss">
.ck-editor__editable {
    transition: background-color 0.3s ease;
}
</style>
